import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { callbacks: () => import('./CallbacksPage.vue') },
} satisfies FeatureRoutes
